/**
 * Keeps a single decimal separator and drops anything that is not a number, so
 * a target can be typed with either separator without the field fighting back.
 */
export const sanitizeTargetInput = (raw: string): string => {
  const cleaned = raw.replace(/[^\d.,]/g, '').replace(/,/g, '.');
  const [head, ...rest] = cleaned.split('.');
  if (!rest.length) return head ?? '';
  return `${head}.${rest.join('')}`;
};

/**
 * The target a typed field stands for. Undefined only for an empty field, which
 * is what clears the target — 0 is a target like any other, and a project may
 * well aim for it.
 */
export const parseTargetInput = (raw: string): number | undefined => {
  const trimmed = raw.trim();
  if (!trimmed) return undefined;
  const parsed = Number(trimmed);
  return Number.isFinite(parsed) && parsed >= 0 ? parsed : undefined;
};
